import React, { Component } from 'react';

class Home extends Component {
  render() {
    return (
      <p className="Home-intro">
        To get started, edit <code>src/App.js</code> and save to reload.
      </p>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/Page/Home/Home.js